import React from 'react';
import { Box, Divider, IconButton } from '@mui/material';
import { ArrowBack, SearchIcon } from '../Icons';

interface PageHeaderMobileProps {
	onClick: any;
	setCollapse?: (value: boolean) => void;
	collapse?: boolean;
	title: string;
	contentRight?: any;
	hideSearch?: boolean;
}

const PageHeaderMobile: React.FC<PageHeaderMobileProps> = ({
	onClick,
	setCollapse,
	collapse,
	title,
	contentRight,
	hideSearch = false,
}) => {
	return (
		<div style={{ flexShrink: 0 }}>
			<Box
				display="flex"
				justifyContent="space-between"
				alignItems="center"
				px={2}
				width="100%"
				height="56px"
				flexShrink={0} // Prevents resizing when the content overflows
			>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<IconButton onClick={onClick} size="large">
						<ArrowBack />
					</IconButton>
					<Box>
						<p
							style={{
								color: '#5C5C5C',
								fontFamily: 'Poppins',
								fontSize: '16px',
								fontWeight: 400,
							}}
						>
							{title}
						</p>
					</Box>
				</div>
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
					{contentRight}
					{!hideSearch && setCollapse ? (
						<IconButton onClick={() => setCollapse(!collapse)}>
							<SearchIcon />
						</IconButton>
					) : null}
				</div>
			</Box>
			<Divider style={{ width: '100%' }} />
		</div>
	);
};

export default PageHeaderMobile;
